module.exports = __webpack_public_path__ + "static/atlas-hero-foreground-2279a10c7702f8da443dcf3160406e70.webp";